import { BREAKPOINTS } from '../config.js';
import { initSlider } from './splide-sett.js';

const { mqTouch } = BREAKPOINTS;

const autoplaySplides = document.querySelectorAll('.autoplay__splide');

const mq = window.matchMedia(`(max-width: ${mqTouch}px)`);

autoplaySplides.forEach(container => {
  const isLoop = !container.hasAttribute('data-no-loop');

  const splide = initSlider(container, {
    type: 'fade',
    rewind: isLoop,

    updateOnMove: false,
    perPage: 1,
    autoplay: true,
    interval: 5000,
    pauseOnHover: true,

    drag: false, // Отключаем перетаскивание слайда мышью
    swipe: false, // Отключаем свайпы на мобильных устройствах
    keyboard: false, // Отключаем управление стрелками клавиатуры
    wheel: false, // Отключаем прокрутку колесом мыши
  });

  if (!splide) return;

  const { Autoplay, Controller } = splide.Components;

  const arrows = container.querySelector('.arrows');
  const arrowsPrev = container.querySelector('.arrows__prev');
  const arrowsNext = container.querySelector('.arrows__next');
  const arrowLoader = container.querySelector('.arrow-loader');
  const progressCircle = arrowLoader?.querySelector('.progress');

  if (!arrowLoader || !progressCircle) return;

  const duration = splide.options.interval || 5000;

  let isHovered = false;
  let isStoppedAtEnd = false;

  const isAtEnd = () => !isLoop && splide.index >= Controller.getEnd();

  function resetLoader() {
    progressCircle.style.animation = 'none';
    progressCircle.getBoundingClientRect();
  }

  function startLoader() {
    resetLoader();
    if (isAtEnd()) return;
    progressCircle.style.animation = `progress-circle ${duration}ms linear infinite`;
  }

  function pauseLoader() {
    resetLoader();
    progressCircle.style.animationPlayState = 'paused';
  }

  function playAutoplay() {
    if (isAtEnd() || isHovered) return;
    Autoplay.play();
    startLoader();
  }

  function syncEndState() {
    if (isAtEnd()) {
      isStoppedAtEnd = true;
      Autoplay.pause();
      resetLoader();
    } else if (isStoppedAtEnd) {
      isStoppedAtEnd = false;
      playAutoplay();
    }
  }

  startLoader();
  syncEndState();

  splide.on('autoplay:play', startLoader);
  splide.on('autoplay:pause', pauseLoader);
  splide.on('move', syncEndState);

  function handleClick() {
    startLoader();
  }

  function handleMouseEnter() {
    isHovered = true;
    Autoplay.pause();
    pauseLoader();
  }

  function handleMouseLeave() {
    isHovered = false;
    playAutoplay();
  }

  function addMobileListeners() {
    isHovered = false;

    arrowsPrev?.addEventListener('click', handleClick);
    arrowsNext?.addEventListener('click', handleClick);

    arrows?.removeEventListener('mouseenter', handleMouseEnter);
    arrows?.removeEventListener('mouseleave', handleMouseLeave);
  }

  function addDesktopListeners() {
    arrowsPrev?.removeEventListener('click', handleClick);
    arrowsNext?.removeEventListener('click', handleClick);

    arrows?.addEventListener('mouseenter', handleMouseEnter);
    arrows?.addEventListener('mouseleave', handleMouseLeave);
  }

  function checkMode(e) {
    if (e.matches) {
      addMobileListeners();
    } else {
      addDesktopListeners();
    }
  }

  checkMode(mq);
  mq.addEventListener('change', checkMode);

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      Autoplay.pause();
    } else {
      playAutoplay();
    }
  });
});
